import { render, staticRenderFns } from "./importDsp.vue?vue&type=template&id=2395d26d&scoped=true"
import script from "./importDsp.vue?vue&type=script&lang=js"
export * from "./importDsp.vue?vue&type=script&lang=js"
import style0 from "./importDsp.vue?vue&type=style&index=0&id=2395d26d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395d26d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2395d26d')) {
      api.createRecord('2395d26d', component.options)
    } else {
      api.reload('2395d26d', component.options)
    }
    module.hot.accept("./importDsp.vue?vue&type=template&id=2395d26d&scoped=true", function () {
      api.rerender('2395d26d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/ImportCmp/importDsp.vue"
export default component.exports